import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";

import Header from "design-system/resources/html/components/common/header/header";
import NavbarMobile from "design-system/resources/html/components/common/navbar-mobile/navbar-mobile";

import RiskWarningBar from "design-system/resources/html/components/common/risk-warning-bar/risk-warning-bar";

import CompareAccounts from "design-system/resources/html/components/account-overview/compare-accounts/compare-accounts";
import getIdCarouselForAutoSlide from "./carousel";
import getIdCarouselForGlideSlide from './glide';
import messengerSet from "design-system/resources/html/components/common/messengers/messengers";
import setupLanguageSwitcher from './language-switcher';

window.onload = function () {
  Header();
  setupLanguageSwitcher();
  NavbarMobile();
  getIdCarouselForAutoSlide();
  RiskWarningBar();
  CompareAccounts();
  getIdCarouselForGlideSlide();
  messengerSet();
};
